import ztComponent from './ztSizeProvider.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
